export enum ReportType {
	Weekly = 1,
	Monthly = 2
}
